import { LoadingPage } from '@src/common/components/LoadingPage';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { AddNote } from '@src/notes/components/AddNoteComponent';
import { useFindAllNotesForOrder } from '@src/notes/hooks/useFindAllNotesForOrder';
import { NoteTable } from '@src/orders/components/note/NoteTable';

interface Props {
  orderId: string;
}

export const OrderNotes = ({ orderId }: Props) => {
  const {
    notes,
    isLoading,
    refetch: refetchNotes,
  } = useFindAllNotesForOrder({ orderId });

  if (isLoading) {
    return <LoadingPage />;
  }

  const hasNotes = notes.length > 0;

  return (
    <Stack gap={theme.spacing['3']}>
      <AddNote
        isInitiallyAddingNote={!hasNotes}
        parentType="ORDER"
        parentId={orderId}
        onAddNote={refetchNotes}
      />
      {hasNotes && <NoteTable notes={notes} />}
    </Stack>
  );
};
